/** @format */

export const LOGO_IMG_SRC = './cNepho Logo-02.png'
export const HERO_IMG_SRC = './Rectangle.png'
export const BACKGROUND_WAVE_SRC = './assets/backgroundWave.png'
export const BACKGROUND_WAVE_2_SRC = './assets/backgroundWave2.png'
